import { useUser } from '@clerk/nextjs';
import { useLabResultsEnabled } from '@web-app/utils/feature-flags/lab-results';
import { trpc } from '@web-app/utils/trpc';

/** A patient's lab results for the in-session sidebar, read only while the tab is open. */
export function useInSessionLabResults(patientId: string, isActive: boolean) {
  const enabled = useLabResultsEnabled();
  const { user, isLoaded } = useUser();
  const query = trpc.labResults.get.useQuery(
    // viewerId keys the cache per signed-in user; the server ignores it.
    { patientId, viewerId: user?.id ?? '' },
    {
      enabled: enabled && isActive && isLoaded && Boolean(patientId),
      retry: false,
    },
  );

  return { panels: query.data, isLoading: query.isPending };
}
